/**
 * units - Zentrale Einheiten-Umrechnung für die 3D-Szene
 *
 * Canvas-Konvention im Editor: 1 px = 1 cm (pixelsPerCm = 1, siehe
 * DimensionTooltip/DynamicGardenObjectProperties). Die 3D-Welt rechnet in
 * Metern. Alle px→m-Umrechnungen laufen ausschließlich über dieses Modul,
 * damit eine spätere Kalibrierungs-Anbindung nur eine Stelle ändert.
 *
 * Koordinaten-Mapping: Canvas (x, y) → Welt (x, z); die Welt-y-Achse ist
 * die Höhe. Damit entspricht die Draufsicht in 3D exakt dem 2D-Plan
 * (kein gespiegelter Garten).
 */

export const CM_PER_M = 100;

/**
 * Convert canvas pixels to meters.
 * @param {number} px - Canvas pixels
 * @param {number} pixelsPerCm - Scale factor (default: 1 px = 1 cm)
 * @returns {number} meters
 */
export function pxToM(px, pixelsPerCm = 1) {
  return px / (pixelsPerCm * CM_PER_M);
}

/**
 * Convert centimeters (e.g. DB-Wuchsdaten, Objekthöhen) to meters.
 * @param {number} cm
 * @returns {number} meters
 */
export function cmToM(cm) {
  return cm / CM_PER_M;
}

/**
 * Map a canvas point {x, y} (px) to a world ground point {x, z} (m).
 * @param {{x: number, y: number}} point
 * @param {number} pixelsPerCm
 * @returns {{x: number, z: number}}
 */
export function pointToWorld(point, pixelsPerCm = 1) {
  return {
    x: pxToM(point.x, pixelsPerCm),
    z: pxToM(point.y, pixelsPerCm),
  };
}
